function normalizeEmail(email) {
    if (!email) {
        return '';
    }
    return String(email).trim().toLowerCase();
}

// Feature flags (frontend-only)
//
// Goal: allow you to roll out UI changes to a handful of people without backend work.
// This is NOT a security boundary (the code still ships to the browser); it’s only a UI gate.
//
// To allow someone to see the “Exact contract value” fields, add their email here:
const exactContractValueAllowlist = [
    // 'person@company.com',
    'marco.pettuco@openstartups.net',
    'daniel.vasserma@openstartups.net',
];

export function canSeeExactContractValue(user) {
    const email = normalizeEmail(user?.email);
    if (!email) {
        return false;
    }
    return exactContractValueAllowlist.includes(email);
}

